import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions } from 'src/actions';
import { Modal } from 'src/components/atoms/Modal';
import { modals } from 'src/components/routes/modals';
import { ReduxState } from 'src/reducers';

export const Modals: React.FC = () => {
  const { name, data, style } =
    useSelector((state: ReduxState) => state.modals) ?? {};

  const dispatch = useDispatch();

  if (!name) {
    return null;
  }

  const dismiss = () => dispatch(actions.ui.modal.hide());

  const Component = modals[name];

  return (
    <Modal visible={!!name} dismiss={dismiss} style={style}>
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      <Component {...(data as any)} />
    </Modal>
  );
};
